import http from "@/api/http.js";

export function getAttributes() {
  return http.get("attributes").then(data => {
    return data;
  });
}

export function getAttributesValuesOptions(attributeId) {
  return http.get(`attributes/values/${attributeId}`).then(data => {
    return data;
  });
}

export function addAttribute(code, attributeValueId, addToAllUnificado) {
  return http
    .post(`attributes/add`, {
      code,
      attributeValueId,
      addToAllUnificado
    })
    .then(data => {
      return data;
    });
}
export function addCustomAttribute(code, attributeId, attributeValue) {
  return http
    .post(`attributes/add_custom`, {
      code,
      attributeId,
      attributeValue
    })
    .then(data => {
      return data;
    });
}

export function deleteAttributeRelation(id, deleteFromAllUnificado) {
  return http.get(
    `attributes/delete_relation/${id}?deleteFromAllUnificado=${
      deleteFromAllUnificado ? 1 : 0
    }`
  );
}
